// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forgot-password-form-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(120deg, #5616ea, #320661) !important;
  background-color: #5616ea;
  padding: 20px;
  box-sizing: border-box;
}

.forgot-password-form {
  background-color: #ffffff;
  padding: 20px 30px;
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 500px;
  box-sizing: border-box;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.forgot-password-form:hover {
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
}

.forgot-form-title {
  font-size: 2rem;
  font-weight: 700;
  margin: 0 0 8px 0;
  color: #111827;
  text-align: left;
  margin-bottom: 1.2rem;
}

.forgot-password-input {
  display: flex;
  margin-bottom: 1.25rem;
  width: 100%;
}

.forgot-password-input input {
  width: 100%;
  padding: 0.75rem 1rem;
  font-size: 1rem;
  border-radius: 8px;
  border: 1px solid #ced4da;
  background-color: #f8f9fa;
  color: #495057;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.forgot-password-input input::placeholder {
  color: #6c757d;
  font-weight: 400;
}

.forgot-password-input input:focus {
  outline: none;
  border-color: #5616ea;
  box-shadow: 0 0 0 2px #5616ea15;
}

.submit-area {
  margin-top: 1.5rem;
  width: 100%;
}

.submit-forgot-password {
  width: 100%;
  padding: 0.75rem;
  border-radius: 8px;
  border: none;
  font-size: 1rem;
  font-weight: 600;
  background-color: #5616ea;
  color: #ffffff;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.submit-forgot-password:hover {
  background-color: #4a14d6;
  transform: translateY(-2px);
}

.submit-forgot-password:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

.forgot-password-loader {
  border: 2px solid #ffffff;
  border-top: 2px solid #4a14d6;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  animation: spin 1s linear infinite;
  margin-left: 8px;
}

.forgot-password-message {
  color: #28a745;
  margin-top: 1rem;
  font-size: 0.95rem;
  font-weight: 600;
  text-align: center;
}

.forgot-password-error {
  color: #dc3545;
  margin-top: 1rem;
  font-size: 0.95rem;
  font-weight: 600;
  text-align: center;
}

.signup-row {
  text-align: center;
  color: #6b7280;
  font-size: 0.95rem;
}

.forgot-signup-link {
  color: #111827;
  font-weight: 700;
  margin-left: 4px;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@media (max-width: 480px) {
  .forgot-password-form {
      padding: 30px 20px;
  }

  .forgot-form-title {
      font-size: 1.75rem;
  }

  .submit-forgot-password {
      font-size: 0.95rem;
      padding: 0.65rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ForgotPassword.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gEAAgE;EAChE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;EACzC,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,qDAAqD;AACvD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,wDAAwD;AAC1D;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,2DAA2D;EAC3D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE;MACI,kBAAkB;EACtB;;EAEA;MACI,kBAAkB;EACtB;;EAEA;MACI,kBAAkB;MAClB,gBAAgB;EACpB;AACF","sourcesContent":[".forgot-password-form-container {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 100vh;\r\n  background: linear-gradient(120deg, #5616ea, #320661) !important;\r\n  background-color: #5616ea;\r\n  padding: 20px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.forgot-password-form {\r\n  background-color: #ffffff;\r\n  padding: 20px 30px;\r\n  border-radius: 12px;\r\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);\r\n  width: 100%;\r\n  max-width: 500px;\r\n  box-sizing: border-box;\r\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\r\n}\r\n\r\n.forgot-password-form:hover {\r\n  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.forgot-form-title {\r\n  font-size: 2rem;\r\n  font-weight: 700;\r\n  margin: 0 0 8px 0;\r\n  color: #111827;\r\n  text-align: left;\r\n  margin-bottom: 1.2rem;\r\n}\r\n\r\n.forgot-password-input {\r\n  display: flex;\r\n  margin-bottom: 1.25rem;\r\n  width: 100%;\r\n}\r\n\r\n.forgot-password-input input {\r\n  width: 100%;\r\n  padding: 0.75rem 1rem;\r\n  font-size: 1rem;\r\n  border-radius: 8px;\r\n  border: 1px solid #ced4da;\r\n  background-color: #f8f9fa;\r\n  color: #495057;\r\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\r\n}\r\n\r\n.forgot-password-input input::placeholder {\r\n  color: #6c757d;\r\n  font-weight: 400;\r\n}\r\n\r\n.forgot-password-input input:focus {\r\n  outline: none;\r\n  border-color: #5616ea;\r\n  box-shadow: 0 0 0 2px #5616ea15;\r\n}\r\n\r\n.submit-area {\r\n  margin-top: 1.5rem;\r\n  width: 100%;\r\n}\r\n\r\n.submit-forgot-password {\r\n  width: 100%;\r\n  padding: 0.75rem;\r\n  border-radius: 8px;\r\n  border: none;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  background-color: #5616ea;\r\n  color: #ffffff;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease, transform 0.2s ease;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.submit-forgot-password:hover {\r\n  background-color: #4a14d6;\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.submit-forgot-password:disabled {\r\n  background-color: #6c757d;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.forgot-password-loader {\r\n  border: 2px solid #ffffff;\r\n  border-top: 2px solid #4a14d6;\r\n  border-radius: 50%;\r\n  width: 16px;\r\n  height: 16px;\r\n  animation: spin 1s linear infinite;\r\n  margin-left: 8px;\r\n}\r\n\r\n.forgot-password-message {\r\n  color: #28a745;\r\n  margin-top: 1rem;\r\n  font-size: 0.95rem;\r\n  font-weight: 600;\r\n  text-align: center;\r\n}\r\n\r\n.forgot-password-error {\r\n  color: #dc3545;\r\n  margin-top: 1rem;\r\n  font-size: 0.95rem;\r\n  font-weight: 600;\r\n  text-align: center;\r\n}\r\n\r\n.signup-row {\r\n  text-align: center;\r\n  color: #6b7280;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.forgot-signup-link {\r\n  color: #111827;\r\n  font-weight: 700;\r\n  margin-left: 4px;\r\n  cursor: pointer;\r\n  text-decoration: underline;\r\n  text-underline-offset: 2px;\r\n}\r\n\r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .forgot-password-form {\r\n      padding: 30px 20px;\r\n  }\r\n\r\n  .forgot-form-title {\r\n      font-size: 1.75rem;\r\n  }\r\n\r\n  .submit-forgot-password {\r\n      font-size: 0.95rem;\r\n      padding: 0.65rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
